import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../axiosBaseQuery';
import typeInProductsApiParsers from './typeInProductsApiParsers';

// ---------- API Slice (merged) ----------
const typeInProductsApi = createApi({
  reducerPath: 'typeInProductsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['TypeInProducts'],
  endpoints: (builder) => ({
    getTypeInProductsList: builder.query<any[], void>({
      query: () => {
        return {
          url: '/lubricant/type-in',
          method: 'GET',
        };
      },
      transformResponse: (res: any): any[] =>
        typeInProductsApiParsers.TypeInProductsListParser(res),
      providesTags: ['TypeInProducts'],
    }),
    createTypeInProduct: builder.mutation<any, any>({
      query: (payload) => ({
        url: '/lubricant/type-in/process',
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['TypeInProducts'],
    }),
    createTypeInProductForVessel: builder.mutation<any, any>({
      query: (payload) => ({
        url: '/lubricant/type-in',
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['TypeInProducts'],
    }),
  }),
});

// ---------- Reducer, Middleware, Path ----------
export const typeInProductsReducer = typeInProductsApi.reducer;
export const typeInProductsMiddleware = typeInProductsApi.middleware;
export const typeInProductsReducerPath = typeInProductsApi.reducerPath;

// ---------- Hooks / Actions ----------
export const {
  useGetTypeInProductsListQuery,
  useCreateTypeInProductMutation,
  useCreateTypeInProductForVesselMutation,
} = typeInProductsApi;
